// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3Zcc_","productName":"Table_productName__ItnB1"};